<template>
  <div class="v-radio">
    <label :for="id">{{text}}</label>
    <input
      @change="$emit('change', value)"
      type="radio"
      :name="name"
      :disabled="disabled"
      :id="id"
      :checked="checked"
    />

  </div>
</template>

<script>
export default {
  name: "v-radio",
  props: {
    text: { type: String },
    name: { type: String },
    value: { type: String },
    disabled: { type: Boolean, default: false },
    checked: { type: Boolean, default: false }
  },
  data() {
    return {
      id: null
    };
  },
  mounted() {
    this.id = this._uid;
  }
};
</script>

<style scoped lang="scss">
@import "../../design/variables.scss";

.v-radio {
  display: flex;
  align-items: left;
  flex-direction: column;
  input[type="radio"] {
    cursor: pointer;
    display: inline-flex;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    align-items: center;
    justify-content: center;
    flex-grow: 0;
    flex-shrink: 0;
    background-color: #fff;
    border: 1px solid map-deep-get($colors, "ornament", "border");
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    position: relative;
    outline: 0;
    margin: 0;
     &:checked{  
      background-color: map-deep-get($colors, "foreground", "action");
    }
    &:checked:before {
      position: absolute;
      height: 8px;
      width: 8px;
      background-color: map-deep-get($colors, "foreground", "inverted");    
      content: "";
      display: block;
      border-radius: 50%;
      box-sizing: border-box;
    }
    &:focus {
      border-color: map-deep-get($colors, "foreground", "action");
    }

    &[disabled] {
      cursor: not-allowed;
      border-color: map-deep-get($colors, "ornament", "divider");
      background-color: map-deep-get($colors, "background", "secondary");
      &:checked:before {
        background-color: map-deep-get($colors, "ornament", "border");
      }
    }
  }
  label {
    display: inline-flex;
    margin-left: 5px;
    cursor: pointer;
    user-select: none;
    padding-bottom: 2px;
  }
}
</style>
